import { createSelector } from 'reselect'

const getState = state => state.CommentsStore

const getFetchRequest = state => getState(state).fetchCommentsRequest

const getComments = state => getState(state).comments

const getCommentsMap = createSelector(
  [getComments],
  comments => (!comments ? {} : comments.entities.comments)
)

const getCommentsResult = createSelector(
  [getComments],
  comments => (!comments ? [] : comments.result)
)

const getCommentsList = createSelector(
  [getCommentsResult, getCommentsMap],
  (result, commentsMap) => result.map(id => commentsMap[id])
)

const getCommentsPagination = state => getState(state).pagination

const getComment = (state, id) => getCommentsMap(state)[id]

export { getFetchRequest, getCommentsList, getComment, getCommentsPagination }
